<template>
  <div class="min-h-screen over bg-gray-50 px-4 py-10">
    <div class="max-w-lg mx-auto flex flex-col justify-between">
      <div class="pb-8">
        <div class="text-center">
          <div class="relative inline-block">
            <div class="w-24 h-24 rounded-full overflow-hidden border border-gray-200 mx-auto">
              <img :src="currentImage" class="w-full h-full object-cover" alt="Profile" />
            </div>
            <!-- <button class="absolute -bottom-2 -right-2 bg-white border border-gray-200 shadow p-1 rounded-xl" @click="dialog = true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V19M5 12H19" stroke="#1C274C" stroke-width="1.8" stroke-linecap="round"/>
              </svg>
            </button> -->
            <button class="absolute inset-0" @click="dialog2 = true" aria-label="open gallery"></button>
          </div>
          <div class="text-lg font-bold mt-2">{{ user_name }}</div>
          <p class="text-gray-500 mt-1 text-sm" dir="ltr">{{ user_mobile }}</p>
        </div>
      </div>

      <div class="grid bg-white border border-gray-150 rounded-xl">
        <div class="p-4 cursor-pointer" @click="goToProfile()">
          <div class="flex gap-4 items-center w-full text-center">
            <div class="p-2 bg-blue-100 rounded-xl flex items-center justify-center">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="3" stroke="#007AFF" stroke-width="1.5"/>
                <path d="M17.9691 20C17.81 17.1085 16.9247 15 11.9999 15C7.07521 15 6.18991 17.1085 6.03076 20" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <span class="text-gray-700 text-sm font-medium w-full text-right">{{ $t('profile') }}</span>
          </div>
        </div>

        <div class="px-4 cursor-pointer" @click="goToPassword()">
          <div class="flex gap-4 items-center w-full text-center border-t border-gray-200 py-3">
            <div class="bg-purple-100 p-2 rounded-xl flex items-center justify-center">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10V8.5C7 6.01472 9.01472 4 11.5 4C13.9853 4 16 6.01472 16 8.5V10" stroke="#9B49B2" stroke-width="1.5" stroke-linecap="round"/>
                <rect x="4" y="10" width="15" height="10" rx="3" stroke="#9B49B2" stroke-width="1.5"/>
              </svg>
            </div>
            <span class="text-gray-700 text-sm font-medium w-full text-right">{{ $t('changePassword') }}</span>
          </div>
        </div>
      </div>

      <!-- Image Gallery Modal -->
      <div v-if="dialog2" class="fixed inset-0 z-999">
        <div class="absolute inset-0 bg-black bg-opacity-60" @click="dialog2 = false"></div>
        <div class="relative z-10 flex h-full w-full bg-white">
          <div class="flex absolute top-32 md:top-20 right-5 items-center justify-between p-1.5 border rounded-full">
            <button class="" @click="dialog2 = false" aria-label="close">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 6L18 18M18 6L6 18" stroke="#111827" stroke-width="1.8" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <div class="flex-1 content-center overflow-hidden p-5">
            <div v-if="!photos || photos.length === 0" class="h-full flex items-center justify-center text-gray-400 text-sm">
              {{ $t('noDataFound') }}
            </div>
            <VueSlickCarousel v-else :arrows="true" :dots="false">
              <div v-for="item in photos" :key="item.ImageId" class="flex flex-col items-center justify-center h-full">
                <img :src="item.ImageUrl" class="max-h-70vh rounded-lg object-contain  mx-auto" />
                <div class="text-center mt-3">
                  <button class="inline-flex items-center gap-2 text-red-600 text-sm" @click="deletePhoto(item)">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 3H15M4 7H20M18 7L17.2 19.2C17.0843 20.8235 15.73 22 14.1031 22H9.89686C8.26998 22 6.91572 20.8235 6.79998 19.2L6 7M10 11V17M14 11V17" stroke="#DC2626" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                    {{ $t('deleteImage') }}
                  </button>
                </div>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </div>

      <!-- Edit Picture Actions Modal -->
      <div v-if="dialog" class="fixed inset-0 z-40">
        <div class="absolute inset-0 bg-black bg-opacity-50" @click="dialog = false"></div>
        <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-90% max-w-sm bg-white border border-gray-200 rounded-2xl shadow-xl overflow-hidden z-50">
          <div class="flex items-center justify-between px-4 py-3 border-b">
            <div class="text-sm font-medium">{{ $t('editProfile') }}</div>
            <img src="/img/zoodkomak.png" class="h-6" alt="logo" />
          </div>
          <div class="p-1">
            <ul class="divide-y">
              <li class="px-4 py-3 text-sm cursor-pointer hover:bg-gray-50" @click="select_file()">{{ $t('selectFromGallery') }}</li>
              <li class="px-4 py-3 text-sm cursor-pointer hover:bg-gray-50" @click="delete_file()">{{ $t('deleteImage') }}</li>
            </ul>
            <input id="fileUpload" type="file" hidden @change="input_file_changed">
          </div>
          <div class="flex items-center justify-end gap-2 px-4 py-3 border-t">
            <button class="text-primary-600 text-sm" @click="dialog = false">{{ $t('cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Carousel, Slide } from 'vue-carousel'
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import { bus } from '../../main'
  export default {
    computed: {
      currentImage () {
        try {
          if (this.photos && Array.isArray(this.photos) && this.photos.length > 0) {
            const last = this.photos[this.photos.length - 1]
            return last && last.ImageUrl ? last.ImageUrl : (this.user_image || '')
          }
          return this.user_image || ''
        } catch (e) {
          return this.user_image || ''
        }
      }
    },
    data () {
      return {
        files: [],
        user_name :'',
        dialog_camera: false,
        isCameraOpen: false,
        user_mobile :'',
        user_image :'',
        dialog: false,
        dialog2: false,
        items: '',
        password: '',
        photos: [],
      }
    },
    components: { VueSlickCarousel },
    mounted () {
      this.profile()
      this.GetUserImages()
    },
    methods:{
      dataURLtoFile(dataurl, filename) {
        try {

          var arr = dataurl.split(',')
          var mime = arr[0].match(/:(.*?);/)[1]
          var bstr = atob(arr[1])
          var n = bstr.length
          var u8arr = new Uint8Array(n)

          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }

          return new File([u8arr], filename, {type: mime})
        } catch (e) {
          bus.$emit('show_toast', [3000, "error on dataURLtoFile"])

        }
      },

      deletePhoto (item) {
        const send_data = {
          ImageId: item.ImageId,
          Phone: this.user_mobile,
          Password: this.password,
          ImageName: item.ImageUrl,
        }
        var self = this
        this.axios.post('/DeleteImage', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('delete  ', response)
              // remove from local list
              try {
                self.photos = (self.photos || []).filter(p => p.ImageId !== item.ImageId)
              } catch (e) {}
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
          }).catch(e => {

        })
      },
      uploadPhoto () {
var self = this;
        var formData = new FormData();
        var phone = localStorage.getItem("phone")
        var password = localStorage.getItem("password")
phone = phone.replace("+98","");
        formData.append("Phone",phone);
        formData.append("Password",password);
        // formData.append("Upload",self.files[0].file);
        var my_file = self.files[0].file
        self.dialog = false;
        var file = this.dataURLtoFile(my_file, 'attach.png')
        formData.append('Upload', file)
        this.axios.post('/AddUserImage', formData, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log('delete  ', response)
              var user_data = JSON.parse(localStorage.getItem('profile'))
              user_data.ThumbPath = response.data.thumbPath;
              localStorage.setItem('profile',JSON.stringify(user_data))

              this.user_image = response.data.thumbPath;
              // self.user_info = response.data.userInfo;
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
          }).catch(e => {

        })
      },
      GetUserImages () {
        const send_data = {
          UserId:this.items.UserId,
          RecType: 0,
        }
        var self = this
        this.axios.post('/GetUserImages', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('user info', response.data.imgs)
              const arr = Array.isArray(response.data.imgs) ? response.data.imgs.slice() : []
              // show newest first
              self.photos = arr.reverse()
              // self.user_info = response.data.userInfo;
            }
          }).catch(e => {

        })
      },
      select_file () {
        document.getElementById('fileUpload').click()
      },
      delete_file () {
        this.files = []
      },
      openCamera () {
        this.isCameraOpen = true
        this.createCameraElement()
        this.dialog_camera = true
      },
      createCameraElement () {
        try {
          const constraints = (window.constraints = {
            audio: false,
            video: true
          })

          navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
              this.$refs.camera.srcObject = stream
            })
            .catch(error => {
              alert(this.$t('deviceNotSupportCamera'))
            })
        } catch (err) {
          alert(err)
        }
      },
      input_file_changed () {
        var self = this
        var reader = new FileReader()
        var f = document.getElementById('fileUpload').files
        reader.onloadend = function () {
          var obj = { file: reader.result, preview: reader.result, upload: 0 }
          self.files.push(obj)
          self.uploadPhoto()
        }
        reader.readAsDataURL(f[0])
      },
      profile () {
        var user_data = JSON.parse(localStorage.getItem('profile'))
        console.log('user_data ', user_data)
        this.items = user_data
        console.log(user_data)
        this.user_name = user_data.UserName
        this.user_image = user_data.ThumbPath
        this.user_mobile = localStorage.getItem('phone')
        this.password = localStorage.getItem('password')
      },
      goToProfile () {
        this.$router.push({ name:this.$t('editProfile'), params:{} })
      },
      goToPassword () {
        this.$router.push({ name:this.$t('sendCode'), params:{} })
      }
    }
  }
</script>
